<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import * as Sentry from '@sentry/vue';
import NextSelect from 'dashboard/components-next/select/Select.vue';

const props = defineProps({
  value: {
    type: String,
    required: true,
    validator: value =>
      [
        'ding',
        'bell',
        'chime',
        'magic',
        'ping',
        'whaticket',
        'livechat',
        'notification-1',
        'notification-2',
        'notification-3',
      ].includes(value),
  },
  label: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const alertTones = computed(() => [
  {
    value: 'ding',
    label: 'Ding',
  },
  {
    value: 'bell',
    label: 'Bell',
  },
  {
    value: 'chime',
    label: 'Chime',
  },
  {
    value: 'magic',
    label: 'Magic',
  },
  {
    value: 'ping',
    label: 'Ping',
  },
  {
    value: 'whaticket',
    label: 'Whaticket',
  },
  {
    value: 'livechat',
    label: 'Livechat',
  },
  {
    value: 'notification-1',
    label: 'Notification 1',
  },
  {
    value: 'notification-2',
    label: 'Notification 2',
  },
  {
    value: 'notification-3',
    label: 'Notification 3',
  },
]);

const selectedValue = computed({
  get: () => props.value,
  set: value => {
    emit('change', value);
  },
});

const audio = new Audio();

const playAudio = async () => {
  try {
    // Has great support https://caniuse.com/mdn-api_htmlaudioelement
    audio.src = `/audio/dashboard/${selectedValue.value}.mp3`;
    await audio.play();
  } catch (error) {
    Sentry.captureException(error);
  }
};
</script>

<template>
  <div class="flex items-center gap-2">
    <div class="flex-grow">
      <label
        class="flex justify-between text-sm font-medium leading-6 text-n-slate-12"
      >
        {{ label }}
      </label>
      <NextSelect v-model="selectedValue" :options="alertTones" />
    </div>
    <button
      v-tooltip.top="
        $t('PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.PLAY')
      "
      class="border-0 shadow-sm outline-none flex justify-center items-center size-10 appearance-none rounded-xl ring-n-weak ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-n-brand flex-shrink-0 mt-[1.75rem]"
      @click="playAudio"
    >
      <Icon icon="i-lucide-volume-2" />
    </button>
  </div>
</template>
